require('./accountDebitReturnSuccess.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { OKLink } = require('commonsComponents/OKLink');
// @ utilities
const { formatAmountObject } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
const receiptNumberHelper = require('utilities/receiptNumberHelper');
const { DATE_FORMAT_EXTENDED } = require('constants/index');

class AccountDebitReturnSuccess extends React.Component {
    buildSuccessMessage() {
        const { issuingCompanyName, receiptNumber, receiptDate, receiptAmount } = this.props;
        const amount =
            formatAmountObject(receiptAmount).amount +
            ' ' +
            formatAmountObject(receiptAmount).currencySymbol;

        const injectedStrings = [
            issuingCompanyName,
            receiptNumberHelper(receiptNumber),
            DateHelper.formatDate(receiptDate, DATE_FORMAT_EXTENDED).toLowerCase(),
            amount
        ];

        return (
            <FormattedText
                value="returnSuccessful-detail"
                injectedStrings={injectedStrings}
            />
        )
    }

    render() {
        const { accountId } = this.props;
        const debitsLink = `/myprofile/accounts/${accountId}/debits`;
        const successMessage = formatText('returnSuccessful-successMessage');
        const tagLabel = formatText('returnSuccessful-successTagLabel');
        const successTagLabelSubMessage = formatText('returnSuccessful-successTagLabelSubMessage');
        const detail = this.buildSuccessMessage();

        return (
            <WizardSuccess
                successMessage={successMessage}
                successSubMessage={tagLabel}
                successTagLabelSubMessage={successTagLabelSubMessage}
            >
                <div className="account-debits-return-success__actions text-right">
                    <p className="account-debits-return-success__detail">
                        {detail}
                    </p>
                    <div className="account-debits-return-success__link">
                        <OKLink modifier="emphasize" to={debitsLink}>
                            <FormattedText value="returnSuccessful-backToDebits" />
                        </OKLink>
                    </div>
                </div>
            </WizardSuccess>
        );
    }
}

AccountDebitReturnSuccess.propTypes = {
    accountId: PropTypes.string.isRequired,
    issuingCompanyName: PropTypes.string.isRequired,
    receiptNumber: PropTypes.string.isRequired,
    receiptDate: PropTypes.string.isRequired,
    receiptAmount: PropTypes.object,
    receiptStatus: PropTypes.string
};

module.exports = AccountDebitReturnSuccess;